import React from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { IBaseProps } from '@rbi-ctg/frontend';
import useMediaQuery, { MediaQuery } from 'hooks/use-media-query';
import { useLocationContext } from 'state/location';
import { IAppDimensions } from 'state/ui';
import { UUID_REGEX_STRING } from 'utils/constants';
import { isItemPickerOrComboRoute, routes } from 'utils/routing';

export interface LayoutBottomContainerProps extends IBaseProps {
  appFooterDimensions: IAppDimensions;
}

const Container = styled.div<{ $bottomInset: number }>`
  display: flex;
  flex-direction: column;
  position: fixed;
  bottom: ${p => p.$bottomInset}px;
  width: 100%;
  z-index: ${Styles.zIndex.overlay + 100};
  ${Styles.mobile`
    bottom: calc(${(p: { $bottomInset: number }) =>
      p.$bottomInset}px + env(safe-area-inset-bottom));
  `}
`;

const LayoutBottomContainer: React.FC<LayoutBottomContainerProps> = ({
  children,
  appFooterDimensions,
  ...props
}) => {
  const {
    location: { pathname },
  } = useLocationContext();
  const { formatMessage } = useIntl();
  const isDesktop = useMediaQuery(MediaQuery.Desktop);

  const getLayoutBottomContainerInset = () => {
    const mobileRoutesWithoutBottomNavbar = [
      routes.cart,
      routes.rewardsOnboarding,
      formatMessage({ id: 'routes.rollUpTheRim' }),
      new RegExp(`${routes.orderConfirmation}/${UUID_REGEX_STRING}`),
    ];

    let layoutBottomContainerInset = 0;
    if (isItemPickerOrComboRoute(pathname) && !isDesktop) {
      layoutBottomContainerInset = 85;
    } else if (!mobileRoutesWithoutBottomNavbar.some(route => !!pathname.match(route))) {
      layoutBottomContainerInset = appFooterDimensions.height;
    }
    return layoutBottomContainerInset;
  };

  return (
    <Container $bottomInset={getLayoutBottomContainerInset()} {...props}>
      {children}
    </Container>
  );
};

export default LayoutBottomContainer;
